import type { ComponentType } from "react";

import { AestheticProceduresPage } from "@/components/flows/steps/council/pages/aesthetic-procedures-page";
import { CouncilPage } from "@/components/flows/steps/council/pages/council-page";
import { ProfessionPage } from "@/components/flows/steps/council/pages/profession-page";
import { TermsPage } from "@/components/flows/steps/council/pages/terms-page";
import { TrainingValidationPage } from "@/components/flows/steps/council/pages/training-validation-page";

export {
  COUNCIL_STEP_ID,
  enterCouncilSubStep,
} from "@/components/flows/steps/council/utils/enter-council-sub-step";

export const COUNCIL_SUB_STEP_COMPONENTS: Record<string, ComponentType> = {
  main: ProfessionPage,
  council: CouncilPage,
  "training-validation": TrainingValidationPage,
  terms: TermsPage,
  "aesthetic-procedures": AestheticProceduresPage,
};

